import { IDeleteEspecificidadeObraUseCase } from "../../../presentation/useCases/delete/delete_especificidade_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteEspecificidadeObraUseCase
 */

export class DeleteEspecificidadeObraUseCase implements IDeleteEspecificidadeObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteEspecificidadeObra(
    idEspecificidadeObra: number,
  ): Promise<void> {
    await this.repository.deleteEspecificidadeObra(idEspecificidadeObra);
  }
}
